module.exports = __webpack_public_path__ + "img/MinimumPackaging.cb8d408b.svg";